import toggleClass from 'utils/DOM/toggleClass'

function toggleShoppingTip() {
  toggleClass('#shopping-tip-wrap', 'd-none', true)
}

export default toggleShoppingTip
